export default __webpack_public_path__ + "static/media/media-auto-5.b90fd5a4.jpg";